/* @flow */
import React from 'react';
import {connect} from 'react-redux';
import NumKeyboard from './NumKeyboard';
import Controls from './Controls';
import TablesControls from '../tables/TablesControls';
import TablesMenu from '../tables/TablesMenu';
import Favourite from './Favourite';
import TablesPopup from '../tables/TablesPopup';
import TablesSmall from '../tables/TablesSmall';
import Receipt from './Receipt';
import Products from './Products';
import PaymentPopup from '../paymentPopup/PaymentPopup';
import CreditPaymentPopup from '../menu/credit/debtDetail/CreditPaymentPopup';
import Menu from '../menu/Menu';
import DivideTable from '../tables/DivideTable';
import UsersPopup from '../creditBill/UsersPopup';
import BarmansPopup from '../menu/report/shifts/BarmansPopup';
import {goHomepage} from '../../common/tables/actions';
import { selectProduct } from '../../common/categories/actions';
import { openMessage } from '../../common/components/messages/actions';
import { uploadLogs } from '../../common/logs/actions';
import {
    print,
    printToKitchen,
    countVatsItesPrices,
    containsKitchenItemsToPrint,
    preparePrintArray,
    isNeedArrayPrint,
    printToKitchenNew,
    prepareKitchenPrintArray,
    isEnv
} from '../../common/lib/util';
import moment from 'moment';
import {
    fetchInitApp,
    clearReceipt,
    payOrder,
    setStateOffline,
    setStateOnline,
    setAllowSale, waitingOrdersSetNotInProgress, sendWaitingOrder
} from '../../common/categories/actions';
import {closePaymentPopup} from '../../common/paymentPopup/actions';

let cronRun = 0;
class HomePage extends React.Component {

    state: State = {
        portrait: false,
        cronCountState: 0
    };

    static propTypes = {
        fetchInitApp: React.PropTypes.func,
        billPrintAllowed: React.PropTypes.bool,
        openMessage: React.PropTypes.func,
        uploadLogs: React.PropTypes.func,
        selectProduct: React.PropTypes.func,
        waitingOrdersSetNotInProgress: React.PropTypes.func,
        sendWaitingOrder: React.PropTypes.func,
        payOrder: React.PropTypes.func,
        clearReceipt: React.PropTypes.func,
        setAllowSale: React.PropTypes.func,
        closePaymentPopup: React.PropTypes.func,
        setStateOffline: React.PropTypes.func,
        setStateOnline: React.PropTypes.func,
        paymentPopupVisible: React.PropTypes.bool,
        showBarmansPopup: React.PropTypes.bool,
        openHabituesPanel: React.PropTypes.bool,
        newTableVisible: React.PropTypes.bool,
        tableDivideVisible: React.PropTypes.bool,
        payingInProgress: React.PropTypes.bool,
        waitingOrdersSendToServerInProgress: React.PropTypes.bool,
        tablesVisible: React.PropTypes.bool,
        menuVisible: React.PropTypes.bool,
        itemsFromPaymentPopup: React.PropTypes.object,
        selectedProducts: React.PropTypes.object,
        waitingOrders: React.PropTypes.object,
        itemsDivideTo: React.PropTypes.object,
        logs: React.PropTypes.object,
        organization: React.PropTypes.object,
        cashboxes: React.PropTypes.object,
        kitchenToPrint: React.PropTypes.object,
        orderToPrint: React.PropTypes.object,
        vats: React.PropTypes.object,
        receiptToStorno: React.PropTypes.object,
        viewer: React.PropTypes.object,
        tables: React.PropTypes.object,
        bar: React.PropTypes.object,
        branch: React.PropTypes.object,
        selectedCashbox: React.PropTypes.object,
        showTableId: React.PropTypes.string,
        lastBillNum: React.PropTypes.number,
        kitchenPrintLength: React.PropTypes.number,
        printLength: React.PropTypes.number,
        deviceId: React.PropTypes.number,
        discount: React.PropTypes.number,
        totalPriceVat: React.PropTypes.number,
        hideMouse: React.PropTypes.bool,
        silentPrint: React.PropTypes.bool,
        kitchenPrint: React.PropTypes.bool,
        printType: React.PropTypes.string,
        kitchenPrintType: React.PropTypes.string,
        printAddress: React.PropTypes.string,
        kitchenPrintAddress: React.PropTypes.string,
        kitchenItemsPrintSeparate: React.PropTypes.bool,
        msg: React.PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.doOrder = this.doOrder.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.cronFunction = this.cronFunction.bind(this);
        this.sendWaitingOrders = this.sendWaitingOrders.bind(this);
        this.print = this.print.bind(this);
    }

    componentDidMount() {
        const {fetchInitApp, bar, deviceId, openMessage} = this.props;
        fetchInitApp(bar.get('id'), deviceId).payload.promise
            .then(res => {
                if (Math.abs(Date.now() - res.data.serverTime) > 300000) {
                    const format = 'D.M.YYYY H:mm';
                    openMessage("Zkontrolujte čas na zařízení.", `Čas na tomto zařízení je ${moment().format(format)}, ale server má ${moment(res.data.serverTime).format(format)}.`); // TODO locale
                }
            })
            .catch(() => {

            });
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount() {
        const {clearReceipt} = this.props;
        window.removeEventListener('resize', this.handleResize);
        cronRun = cronRun + 1;
        clearReceipt();
    }

    componentWillMount() {
        const {goHomepage, showTableId} = this.props;
        if (!showTableId) {
            goHomepage();
        }
        cronRun = cronRun + 1;
        this.setState({cronCountState: cronRun});
        this.cronFunction(true);
    }

    cronFunction(firstRun) {
        const {cronCountState} = this.state;
        function doCron(sendFunction, cronCountState, firstRun) {
            setTimeout(function(){
                if (!firstRun && cronCountState !== cronRun) {
                    return;
                }
                try {
                    sendFunction();
                } catch (e) {
                    doCron(sendFunction, cronCountState);
                }
            }, 10 * 60 * 1000);
        }
        doCron(this.sendWaitingOrders, cronCountState, firstRun);
    }

    /**
     * Send waiting orders and logs
     */
    sendWaitingOrders() {
        const {sendWaitingOrder, waitingOrders, viewer, waitingOrdersSendToServerInProgress, logs,
            waitingOrdersSetNotInProgress, payingInProgress, deviceId, uploadLogs} = this.props;

        if (!payingInProgress && !!viewer && !waitingOrdersSendToServerInProgress && waitingOrders.size > 0) {
            sendWaitingOrder(waitingOrders, deviceId).payload.promise
                .then(() => {
                    setStateOnline();
                    this.cronFunction();
                })
                .catch(() => {
                    waitingOrdersSetNotInProgress();
                    setStateOffline();
                    this.cronFunction();
                });
        } else {
            this.cronFunction();
        }

        if (!!viewer && logs.size > 0) {
            uploadLogs(logs, deviceId);
        }
    }

    handleResize(e) {
        const html = document.documentElement;
        const body = document.body;

        let height = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight);

        let width = Math.max(body.scrollWidth, body.offsetWidth,
            html.clientWidth, html.scrollWidth, html.offsetWidth);

        this.setState({portrait: height > width});
    }

    doOrder(storno, isTable, isFromPaymentPopup) {
        const {
            payOrder, selectedProducts, payingInProgress, bar, branch, lastBillNum, deviceId,
            closePaymentPopup, setStateOffline, setStateOnline, receiptToStorno, kitchenPrint,
            selectedCashbox, tables, showTableId, discount: discountPercent, viewer, itemsFromPaymentPopup, vats
        } = this.props;

        if (!!payingInProgress) {
            return;
        }

        let sellerId = viewer.get('userId');
        let discount = discountPercent;
        let note;
        let paymentType = selectedCashbox.get('type');
        let cashboxId = selectedCashbox.get('id');
        let items;
        let containsKitchenItems = false;
        let stornoReceiptId;

        if (storno) {
            items = receiptToStorno.get('selectedProducts');
            paymentType = receiptToStorno.get('paymentType');
            cashboxId = receiptToStorno.get('cashbox');
            discount = receiptToStorno.get('discount');
            stornoReceiptId = receiptToStorno.get('number');
        } else if (isTable) {
            items = itemsFromPaymentPopup;
            if (!!showTableId) {
                note = tables.getIn([showTableId, 'name']);
            }
        } else if (!!isFromPaymentPopup) {
            items = itemsFromPaymentPopup;
        } else {
            items = selectedProducts;
        }

        if (items.size === 0) {
            return;
        } else if (containsKitchenItemsToPrint(items)) {
            containsKitchenItems = true;
        }

        const takeaway = false;
        const barId = bar.get('id');
        const branchId = branch.get('eetBranchId');
        const number = lastBillNum + 1;
        const sellTime = new Date();
        const vatsMap = countVatsItesPrices(vats, items);

        closePaymentPopup();
        payOrder({branchId, items, discount, takeaway, paymentType, cashboxId, deviceId, barId, number,
            sellTime, storno, note, sellerId, stornoReceiptId}, isTable, vatsMap, containsKitchenItems, kitchenPrint)
            .payload.promise
            .then(res => {
                this.print(isTable, storno, containsKitchenItems);
                setStateOnline();
            })
            .catch(res => {
                this.print(isTable, storno, containsKitchenItems);
                setStateOffline();
            });
    }

    print(isTable, storno, containsKitchenItems) {
        const {
            setAllowSale, printType, kitchenPrint, bar, organization, branch, cashboxes, orderToPrint,
            deviceId, silentPrint, printAddress, kitchenPrintType, kitchenPrintAddress, kitchenToPrint,
            printLength, kitchenPrintLength, billPrintAllowed, kitchenItemsPrintSeparate, msg
        } = this.props;

        const printArray = !!isNeedArrayPrint(printType)
            ? preparePrintArray(bar, organization, orderToPrint, branch, cashboxes, null, null, null, deviceId, msg)
            : null;

        print(printType, printAddress, printArray, silentPrint, printLength, true, billPrintAllowed);

        if (isEnv(['android_app', 'electron'])) {
            if (typeof window.parent.Ocellot !== 'undefined' && typeof window.parent.Ocellot.printEscpos === 'function') {
                if (!isTable && !storno && containsKitchenItems && kitchenPrintType !== 'off') {
                    const printArrayKitchen = !!isNeedArrayPrint(kitchenPrintType)
                        ? prepareKitchenPrintArray(bar.get('name'), kitchenToPrint, kitchenItemsPrintSeparate, msg)
                        : null;
                    printToKitchenNew(false, kitchenPrintType, kitchenPrintAddress, printArrayKitchen, kitchenPrintLength);
                }
            } else {
                if (!isTable && !storno && containsKitchenItems && kitchenPrint) {
                    printToKitchen();
                }
            }
        }

        window.setTimeout(function () {
            setAllowSale();
        }, 3500);
    }

    render() {
        const {paymentPopupVisible, menuVisible, tablesVisible, showTableId, tableDivideVisible, selectProduct,
            hideMouse, newTableVisible, openHabituesPanel, totalPriceVat, selectedProducts, itemsDivideTo,
            showBarmansPopup, bar
        } = this.props;
        const {portrait} = this.state;

        return (
            <div className={`global ${portrait ? 'portrait' : ''} ${hideMouse ? 'no-mouse' : ''}`}>
                {paymentPopupVisible && !menuVisible &&
                    <PaymentPopup homepage={this}
                                  selectedProducts={selectedProducts}
                                  itemsDivideTo={itemsDivideTo}
                                  totalPriceVat={totalPriceVat}/>
                }
                {paymentPopupVisible && menuVisible &&
                    <CreditPaymentPopup />
                }
                {menuVisible &&
                <Menu homepage={this}/>
                }
                {!menuVisible && tablesVisible &&
                <TablesPopup barId={bar.get('id')} />
                }
                {tableDivideVisible &&
                    <DivideTable />
                }
                {openHabituesPanel &&
                    <UsersPopup />
                }
                {showBarmansPopup &&
                    <BarmansPopup />
                }
                {!menuVisible && !newTableVisible &&
                    <div id="cashbox" className="pageCashbox">

                      <div className="pageCashbox-receipt">
                        <Receipt />
                      </div>

                      <div className="pageCashbox-products">
                        <Products maxButtons={portrait ? 12 : 25} selectProduct={selectProduct} />
                      </div>

                      <div className="pageCashbox-numpad">
                        <NumKeyboard />
                      </div>

                      <div className="pageCashbox-tables">
                        {!!showTableId
                            ? <TablesMenu />
                            : <TablesSmall />
                        }
                      </div>

                      <div className="pageCashbox-favourite">
                        <Favourite/>
                      </div>

                      <div className="pageCashbox-controls">
                        {!!showTableId
                            ? <TablesControls homepage={this} />
                            : <Controls homepage={this}/>
                        }
                      </div>
                    </div>
                }
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    orderToPrint: state.categories.get('orderToPrint'),
    organization: state.categories.get('organization'),
    cashboxes: state.cashboxes.get('cashboxes'),
    hideMouse: state.device.hideMouse,
    paymentPopupVisible: state.paymentPopup.get('paymentPopupVisible'),
    vats: state.categories.get('vats'),
    selectedProducts: state.categories.get('selectedProducts'),
    payingInProgress: state.categories.get('payingInProgress'),
    menuVisible: state.menu.get('menuVisible'),
    tablesVisible: state.tables.get('tablesVisible'),
    bar: state.bars.get('bar'),
    newTableVisible: state.tables.get('newTableVisible'),
    tables: state.categories.get('tables'),
    branch: state.branches.get('branch'),
    viewer: state.users.get('viewer'),
    selectedCashbox: state.cashboxes.get('selectedCashbox'),
    showTableId: state.categories.get('showTableId'),
    tableDivideVisible: state.tables.get('tableDivideVisible'),
    itemsDivideTo: state.categories.get('itemsDivideTo'),
    lastBillNum: state.categories.get('lastBillNum'),
    receiptToStorno: state.categories.get('receiptToStorno'),
    waitingOrders: state.categories.get('waitingOrders'),
    waitingOrdersSendToServerInProgress: state.categories.get('waitingOrdersSendToServerInProgress'),
    deviceId: state.device.get('id'),
    logs: state.logs.get('logs'),
    discount: state.paymentPopup.get('discount'),
    itemsFromPaymentPopup: state.paymentPopup.get('items'),
    openHabituesPanel: state.creditBill.get('openHabituesPanel'),
    totalPriceVat: state.categories.get('totalPriceVat'),
    silentPrint: state.device.get('silentPrint'),
    printType: state.device.get('printType'),
    billPrintAllowed: state.device.get('billPrint'),
    printLength: state.device.get('printLength'),
    kitchenPrintType: state.device.get('kitchenPrintType'),
    kitchenPrintLength: state.device.get('kitchenPrintLength'),
    kitchenPrintAddress: state.device.get('kitchenPrintAddress'),
    printAddress: state.device.get('printAddress'),
    kitchenPrint: state.device.get('kitchenPrint'),
    showBarmansPopup: state.shifts.get('showBarmansPopup'),
    kitchenToPrint: state.categories.get('kitchenToPrint'),
    kitchenItemsPrintSeparate: state.device.kitchenItemsPrintSeparate,
}), {fetchInitApp, clearReceipt, payOrder, closePaymentPopup, setStateOffline, setStateOnline, setAllowSale,
    waitingOrdersSetNotInProgress, sendWaitingOrder, goHomepage, selectProduct, uploadLogs, openMessage})(HomePage);



// WEBPACK FOOTER //
// ./src/browser/home/HomePage.js